export enum ComplexPromotionCondition {
  AND = 'AND',
  ALL = 'ALL'
}

export enum RewardType {
  DISCOUNT = 'DISCOUNT',
  POINTS = 'POINTS',
  PERCENTAGE = 'PERCENTAGE'
}

export enum ComplexPromotionRewardTypeValues {
  DISCOUNT = 0,
  PERCENTAGE = 1
}

export enum ComplexPromotionType {
  MULTI_BUY = 'MULTI_BUY',
  MIX_MATCH = 'MIX_MATCH',
  SELLER_PROMO = 'SELLER_PROMO'
}

export const NUMBER_OF_PRODUCTS_TO_SHOW = 20;

export const PROPOINT_COLLECTION = 'PROPOINT_PROMOTION';
export const DEFAULT = 'DEFAULT';

export const TRANSLATION_KEYS = {
  PROPOINT: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.proPoint',
    DESCRIPTION: 'loyalty.proPointPromotions.complexPromotion.subHeader'
  },
  [ComplexPromotionType.MULTI_BUY]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.multiBuy',
    DESCRIPTION: 'loyalty.proPointPromotions.complexPromotion.multiBuyHeader'
  },
  [ComplexPromotionType.MIX_MATCH]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.comboSet',
    DESCRIPTION: ''
  },
  [ComplexPromotionType.SELLER_PROMO]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.comboSet',
    DESCRIPTION: ''
  }
};

export const PROMOTION_COLORS = {
  PROPOINT: {
    BACKGROUND: '#FFF7D4',
    TEXT: '#835111'
  },
  DEFAULT: {
    BACKGROUND: '#EADEFF',
    TEXT: '#6109FF'
  }
};
